(function () {
  var RESULTS_SECTION_ID = 'search-bar-results';
  var SERIES_SECTION_ID = 'search-bar-series';
  var QUERY_PARAM = 'q';
  var TERM_PLACEHOLDER = '__SEARCH_TERM__';

  // Frame article number, e.g. 1i52-04-3L (Gi52) or 1940-02-00 (G40)
  var FRAME_SKU = /^1([0-9a-z])([0-9a-z]{2})-[0-9a-z]{2}-[0-9a-z]{2}$/i;

  function tokenize(text) {
    return String(text)
      .toLowerCase()
      .replace(/[^a-z0-9äöüß]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  // 1i52-04-3L -> "gi52", 1940-02-00 -> "g40"
  function modelFromFrameSku(term) {
    var match = term.trim().match(FRAME_SKU);
    if (!match) return null;

    var line = match[1].toLowerCase();
    var number = match[2].replace(/^0+(?=.)/, '');

    if (line === 'i') return 'gi' + number;
    if (line === '9') return 'g' + number;
    return null;
  }

  // Series values look like "<model> <series name>", e.g. "Gi52 Lido", "Gi15 St. Pauli", "G40" or just a name ("Sport Drift")
  var MODEL_TOKEN = /^gi?\d+$/;

  function findSeries(term, entries) {
    var model = modelFromFrameSku(term);
    if (model) {
      return entries
        .filter(function (entry) { return entry.tokens[0] === model; })
        .map(function (entry) { return entry.value; });
    }

    var queryTokens = tokenize(term);
    if (!queryTokens.length) return [];

    return entries
      .filter(function (entry) {
        var entryModel = MODEL_TOKEN.test(entry.tokens[0]) ? entry.tokens[0] : null;
        var distinctiveToken = entry.tokens[entry.tokens.length - 1];
        var allTokensInEntry = queryTokens.every(function (token) {
          return entry.tokens.indexOf(token) !== -1;
        });

        if (!allTokensInEntry) return false;

        // Require the model ("gi52") or the distinctive name ("lido", "pauli"), not generic words like "sport" or "st"
        return (
          (entryModel && queryTokens.indexOf(entryModel) !== -1) ||
          queryTokens.indexOf(distinctiveToken) !== -1
        );
      })
      .map(function (entry) { return entry.value; });
  }

  function initSearchBar(section) {
    var form = section.querySelector('.search-bar__form');
    var input = section.querySelector('.search-bar__input');
    var resetBtn = section.querySelector('.search-bar__reset');

    if (!form || !input || !resetBtn) return;

    var action = form.getAttribute('action');
    var seriesParam = section.getAttribute('data-series-param');
    var results = section.hasAttribute('data-inline-results')
      ? section.querySelector('[data-search-bar-results-container]')
      : null;
    var resultsContent = results ? results.querySelector('[data-search-bar-results-content]') : null;
    var controller = null;
    var seriesPromise = null;
    var searchId = 0;

    function toggleReset() {
      if (input.value.length > 0) {
        resetBtn.classList.remove('hidden');
      } else {
        resetBtn.classList.add('hidden');
      }
    }

    // Form fields without the search term (options[prefix], product type restriction)
    function baseParams() {
      var params = new URLSearchParams(new FormData(form));
      params.delete('q');
      return params;
    }

    // All series values of the (restricted) catalog, loaded once per page view
    function loadSeries() {
      if (!seriesPromise) {
        var params = baseParams();
        params.set('q', '*');
        params.set('section_id', SERIES_SECTION_ID);

        seriesPromise = fetch(action + '?' + params.toString())
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var data = doc.querySelector('[data-search-bar-series]');
            var values = data ? JSON.parse(data.textContent) : [];

            return values
              .map(function (value) { return { value: value, tokens: tokenize(value) }; })
              .filter(function (entry) { return entry.tokens.length > 0; });
          })
          .catch(function () {
            seriesPromise = null;
            return [];
          });
      }
      return seriesPromise;
    }

    // Resolves the search parameters: a recognized series becomes a series filter, otherwise a text search
    function buildSearchParams(term) {
      var params = baseParams();

      if (!seriesParam) {
        params.set('q', term);
        return Promise.resolve(params);
      }

      return loadSeries().then(function (entries) {
        var series = findSeries(term, entries);

        if (series.length) {
          params.set('q', '*');
          series.forEach(function (value) { params.append(seriesParam, value); });
        } else {
          params.set('q', term);
        }

        return params;
      });
    }

    // Keep the search term in the page URL so reloads and shared links show the same results
    function updatePageUrl(term) {
      var url = new URL(window.location.href);
      if (term) {
        url.searchParams.set(QUERY_PARAM, term);
      } else {
        url.searchParams.delete(QUERY_PARAM);
      }
      window.history.replaceState(window.history.state, '', url.toString());
    }

    function clearResults() {
      searchId++;
      if (controller) controller.abort();
      results.hidden = true;
      results.classList.remove('is-loading');
      resultsContent.innerHTML = '';
    }

    function loadResults(term) {
      var currentSearch = ++searchId;

      if (controller) controller.abort();
      results.hidden = false;
      results.classList.add('is-loading');

      buildSearchParams(term).then(function (params) {
        if (currentSearch !== searchId) return;

        var searchUrl = action + '?' + params.toString();
        controller = new AbortController();

        fetch(searchUrl + '&section_id=' + RESULTS_SECTION_ID, { signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var rendered = doc.querySelector('[data-search-bar-results]');
            if (!rendered) throw new Error('Search results section not found');

            resultsContent.innerHTML = rendered.innerHTML;

            var count = resultsContent.querySelector('[data-search-bar-results-count]');
            if (count) count.textContent = count.textContent.replace(TERM_PLACEHOLDER, term);

            var allResultsLink = resultsContent.querySelector('[data-search-bar-all-results]');
            if (allResultsLink) allResultsLink.href = searchUrl;

            results.classList.remove('is-loading');
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            // Fall back to the regular search results page
            window.location.href = searchUrl;
          });
      });
    }

    input.addEventListener('input', toggleReset);

    resetBtn.addEventListener('click', function () {
      input.value = '';
      toggleReset();
      input.focus();

      if (results) {
        clearResults();
        updatePageUrl('');
      }
    });

    if (seriesParam) {
      input.addEventListener('focus', loadSeries, { once: true });
    }

    if (results && resultsContent) {
      form.addEventListener('submit', function (event) {
        var term = input.value.trim();
        event.preventDefault();

        if (!term) {
          clearResults();
          updatePageUrl('');
          return;
        }

        updatePageUrl(term);
        loadResults(term);
      });

      var initialTerm = new URL(window.location.href).searchParams.get(QUERY_PARAM);
      if (initialTerm && initialTerm.trim()) {
        input.value = initialTerm.trim();
        loadResults(input.value);
      }
    } else if (seriesParam) {
      // No inline results: open the search results page with the resolved parameters
      form.addEventListener('submit', function (event) {
        var term = input.value.trim();
        if (!term) return;

        event.preventDefault();
        buildSearchParams(term).then(function (params) {
          window.location.href = action + '?' + params.toString();
        });
      });
    }

    toggleReset();
  }

  function init() {
    document.querySelectorAll('[data-section-type="search-bar"]').forEach(initSearchBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="search-bar"]');
    if (section) initSearchBar(section);
  });
})();
